<button mat-flat-button class="tagus fw-semibold" (click)="openCreateVideoDialog('300ms', '100ms')">
    Open Video
</button>